class LoginPopup {
    constructor() {
      this.popup = document.getElementById("login-popup");
      this.init();
    }
  
    init() {
      if (!this.popup) return;
  
      // Add click handlers to all trigger buttons
      document
        .querySelectorAll("[data-login-popup-trigger]")
        .forEach((trigger) => {
          trigger.addEventListener("click", (e) => {
            e.preventDefault();
            this.openPopup();
          });
        });
  
      // Close button handler
      this.popup
        .querySelector(".login-popup-close")
        .addEventListener("click", () => {
          this.closePopup();
        });
  
      // Close on overlay click
      this.popup.addEventListener("click", (e) => {
        if (e.target === this.popup) {
          this.closePopup();
        }
      });
  
      // Close on ESC key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.popup.classList.contains("active")) {
          this.closePopup();
        }
      });
    }
  
    openPopup() {
      let mobileMenu = document.querySelector("fostr-mobilemenu");
      if (mobileMenu.classList.contains("mobilemenu--isVisible")) {
        console.log("ciao");
        mobileMenu.mobilemenuHide();
      }
      this.popup.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  
    closePopup() {
      this.popup.classList.remove("active");
      document.body.style.overflow = "";
    }
  }
  
  // Initialize the login popup
  window.addEventListener("DOMContentLoaded", () => {
    new LoginPopup();
  });
  